const getBackendAdress = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:8080';
    } else {
        return 'https://training-manager-back-end.onrender.com';
    }
}

export const backEndAdress = getBackendAdress();